package ui

data class SnackbarErrorState(
    val open: Boolean = false,
    val message: String = ""
)
